<template>
<div class="home" :style="isMobileDevice()?'min-width: 375px;':'min-width: 1200px;'">
  <div class="qrcode" v-if="dialogFormVisible">
    <img src="@/assets/image/lkqrcode.png" alt="">
  </div>
  <div class="title">
    <div class="title_left">

      <img class="title_img" src="@/assets/image/logo.d8db8b5a.png" alt="">
    </div>
    <div class="title_right">
      <div style="margin-right: 15px; display: inline-block;">
        <el-popover placement="bottom-start">
          <template #reference>
            <el-button link class="button" type="primary">APP</el-button>
          </template>

          <div style="display: flex;align-items: center;justify-content: center;padding: 10px 0px;">
            <div style="text-align: center;">
              <p style="margin:5px 0px; font-size: 14px;">扫码下载 Android app 安装包</p>
              <div id="androidBox">
                
              </div>
            </div>
          </div>
        </el-popover>

        <el-popover placement="bottom-start">
          <template #reference>
            <el-button link class="button" type="primary">H5</el-button>
          </template>

         <div style="display: flex;align-items: center;justify-content: center;padding: 10px 0px;">
            <div style="text-align: center;">
              <p style="margin:5px 0px; font-size: 14px;">微信扫码使用移动端</p>
              <div id="h5Box">
                
              </div>
            </div>
          </div>
        </el-popover>

      </div>

      <el-button link @click="openUrl('http://docs.eztcloud.com/')" class="button" type="primary">前往文档</el-button>
      <el-button link @mouseleave="dialogFormVisible = false" @mouseenter="dialogFormVisible = true" @click="dialogFormVisible = true" class="button" type="primary">联系我们</el-button>
      <el-button v-if="!isMobileDevice()" @click="onTrial" class="button  toPC" style="background-color: #3773F5;" type="primary">立即登录</el-button>
      <el-button v-if="isMobileDevice()" @click="onTrialM" class="button toM" style="background-color: #3773F5;" type="primary">立即登录</el-button>
    </div>

  </div>

  <div class="content" id="specific-scroll-container">

    <div class="box1">
      <div class="box1_title texthover">
        <span class="font_b">EZtCloud</span>
        <span class="font_l">®</span>
        <span class="font_s">.com</span>
      </div>
      <div class="box1_title2 texthover">
        物联网数据中台
      </div>
      <div class="box1_title3">
        极速接入，互联互通
      </div>
      <div class="box1_video_box">
        <img style="width: 100%;height: 100%;cursor: pointer;" src="@/assets/image/zwt.gif" alt="" @click="playVideo">
        <!-- <video controls poster="@/assets/image/zwt.png">
          <source src="" type="video/mp4">
        </video> -->
      </div>

      <div class="box2">
        <div class="texthover box2_title wow animate__animated animate__zoomIn" data-wow-duration="2.5s">
          为什么选择EZtCloud？
        </div>
        <div class="box2_content">
          <div class="boxhover box2_content_1 wow animate__animated animate__flipInY" data-wow-duration="2.5s">
            <span class="content_1_sapan ">开放</span>
            <div class="content_item wow animate__animated animate__flipInX" data-wow-duration="2.5s">
              <img src="@/assets/image/kf1.png" alt="">
              <div class="item_right">
                <div class="item_top">
                  硬件接入完全开放，专业团队免费支持
                </div>
              </div>
            </div>
            <div class="content_item wow animate__animated animate__flipInX" data-wow-duration="2.5s">
              <img src="@/assets/image/kf2.png" alt="">
              <div class="item_right">
                <div class="item_top">
                  开放API，无缝对接第三方系统
                </div>
              </div>
            </div>

          </div>
          <div class="boxhover box2_content_2 wow animate__animated animate__flipInX" data-wow-duration="2s">
            <span class="content_1_sapan">免费</span>
            <span class="content_2_sapan">基础功能永久免费</span>
          </div>
          <div class="boxhover box2_content_3 wow animate__animated animate__flipInX" data-wow-duration="2s">
            <span class="content_1_sapan">设备联动</span>
            <span class="content_2_sapan">让万物互联更简单</span>
          </div>
        </div>

      </div>
    </div>

    <div class="box3">
      <div class="texthover box3_title wow animate__animated animate__zoomIn" data-wow-duration="2.5s">
        EZtCloud方案架构
      </div>
      <div class="box3_content">
        <img style="width: 100%; height: 100%;" src="@/assets/image/fajg.png" alt="">

      </div>
    </div>

    <div class="box4">
      <div class="texthover box4_title wow animate__animated animate__zoomIn" data-wow-duration="2.5s">
        {{tabsMap[activeName]}}
      </div>

      <el-tabs v-model="activeName" class="tabs" >
        <el-tab-pane label="设备兼容" name="device_compatibility">

          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                兼容99+%市面物联网设备
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                常见的MQTT、TCP、Modbus等多种通讯协议
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                支持通过低代码解析私有协议
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                联网设备Topic不可改？Topic映射功能完美解决
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>

            </div>
            <div class="pane-box-right">
              <img style="width: auto; height: 80%;" src="@/assets/image/sbjr.png" alt="">
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="告警通知" name="alarm_notification">
          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                实时推送告警规则触发的现场隐患信息
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                现场隐患及时告知，最大限度降低损失
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                告警规则由你自由定义
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                通知组，支持多种通知方式，确保触达
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
            </div>
            <div class="pane-box-right">
              <img src="@/assets/image/gjtz.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="定时任务" name="scheduled_tasks">
          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                自定义定时下发数据至设备
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                支持单次、重复、周期、整点等定时方式
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                周期执行支持预约首次执行时间
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                整点执行支持整半小时和整小时
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
            </div>
            <div class="pane-box-right">
              <img src="@/assets/image/dsrw.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="OTA升级" name="ota">
          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                支持OTA升级，让远程运维更轻松
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                批量更新设备固件
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                逻辑简单，设备可轻松实现
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                支持设备触发或平台触发
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
            </div>
            <div class="pane-box-right">
              <img src="@/assets/image/ota.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="团队协作" name="team_collaboration">
          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                多成员协作，让项目推进更高效
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                成员权限，安全放心
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                多种成员邀请方式
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                可自由为成员分配设备
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
            </div>
            <div class="pane-box-right">
              <img src="@/assets/image/tdxz.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="移动端" name="mobile_terminal">
          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                支持移动端
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                开箱即用
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                随时随地
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                功能丰富
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
            </div>
            <div class="pane-box-right">
              <img src="@/assets/image/ydd.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="支持私有部署" name="private_deployment">
          <div class="pane-box">
            <div class="pane-box-left">
              <div class="pane-left-title">
                可选私有部署，独享稳定环境
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                数据资产安全可控
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                技术支持售后无忧
              </div>
              <div class="pane-left-text">
                <el-icon color="#3773F5" style="margin: 0 10px;">
                  <CircleCheckFilled />
                </el-icon>
                全国产化，信创合规
              </div>

              <el-button @click="onTrial" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
            </div>
            <div class="pane-box-right">
              <img src="@/assets/image/sybs.png" alt="">
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box41" v-show="isMobileDevice()">

      <div class="box41-box">
        <div class="box41-title">
          设备兼容
        </div>
        <div class="box41-box-right">
          <img src="@/assets/image/sbjr.png" alt="">
        </div>
        <div class="box41-box-left">
          <div class="box41-left-title">
            兼容99+%市面物联网设备
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            常见的MQTT、TCP、HTTP、Modbus等多种通讯协议
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            支持通过低代码解析私有协议
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            联网设备Topic不可改？Topic映射功能完美解决
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

      <div class="box41-box">
        <div class="box41-title">
          告警通知
        </div>

        <div class="box41-box-right">
          <img src="@/assets/image/gjtz.png" alt="">
        </div>

        <div class="box41-box-left">
          <div class="box41-left-title">
            实时推送告警规则触发的现场隐患信息
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            现场隐患及时告知，最大限度降低损失
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            告警规则由你自由定义
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            通知组，支持多种通知方式，确保触达
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

      <div class="box41-box">
        <div class="box41-title">
          定时任务
        </div>
        <div class="box41-box-right">
          <img src="@/assets/image/dsrw.png" alt="">
        </div>
        <div class="box41-box-left">
          <div class="box41-left-title">
            自定义定时下发数据至设备
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            支持单次、重复、周期、整点等定时方式
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            周期执行支持预约首次执行时间
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            整点执行支持整半小时和整小时
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

      <div class="box41-box">
        <div class="box41-title">
          OTA升级
        </div>
        <div class="box41-box-right">
          <img src="@/assets/image/ota.png" alt="">
        </div>
        <div class="box41-box-left">
          <div class="box41-left-title">
            支持OTA升级，让远程运维更轻松
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            批量更新设备固件
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            逻辑简单，设备可轻松实现
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            支持设备触发或平台触发
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

      <div class="box41-box">
        <div class="box41-title">
          团队协作
        </div>
        <div class="box41-box-right">
          <img src="@/assets/image/tdxz.png" alt="">
        </div>
        <div class="box41-box-left">
          <div class="box41-left-title">
            多成员协作，让项目推进更高效
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            成员权限，安全放心
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            多种成员邀请方式
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            可自由为成员分配设备
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

      <div class="box41-box">
        <div class="box41-title">
          移动端
        </div>
        <div class="box41-box-right">
          <img src="@/assets/image/ydd.png" alt="">
        </div>
        <div class="box41-box-left">
          <div class="box41-left-title">
            支持移动端
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            开箱即用
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            随时随地
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            功能丰富
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

      <div class="box41-box">
        <div class="box41-title">
          支持私有部署
        </div>
        <div class="box41-box-right">
          <img src="@/assets/image/sybs.png" alt="">
        </div>
        <div class="box41-box-left">
          <div class="box41-left-title">
            可选私有部署，独享稳定环境
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            数据资产安全可控
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            技术支持售后无忧
          </div>
          <div class="box41-left-text">
            <el-icon color="#3773F5" style="margin: 0 10px;">
              <CircleCheckFilled />
            </el-icon>
            全国产化，信创合规
          </div>

          <el-button @click="onTrialM" class="button" style="background-color: #3773F5; margin-left: 15px;" type="primary">立即登录</el-button>
        </div>

      </div>

    </div>

    <div class="box5">
      <div class="box5_content">
        <div class="box5_title">
          <div class="box5_logo">
            <img src="@/assets/image/logo@2x.png" alt="">
          </div>
          <div>
            零点创新科技有限公司
          </div>
        </div>
      </div>

      <div class="ICP">
        <el-button @click="openUrl('https://beian.miit.gov.cn/')" class="ICP" type="plain" link>
          豫ICP备19028258号
        </el-button>
      </div>

    </div>

  </div>
  <!-- videoBox -->
  <videoBox ref="videoBox" />
</div>
</template>

<script>
import { WOW } from 'wowjs'
import videoBox from "./videoBox.vue"
// import axios from 'axios'

export default {
  components: {
    videoBox,
  },
  data() {
    return {
      dialogFormVisible: false,
      activeName: 'device_compatibility',
      tabsMap: {
        'device_compatibility': '设备兼容',
        'alarm_notification': '告警通知',
        'scheduled_tasks': '定时任务',
        'ota': 'OTA升级',
        'team_collaboration': '团队协作',
        'mobile_terminal': '移动端',
        'private_deployment': '支持私有部署',
      }

    }
  },
  created() {

  },
  computed: {

  },
  mounted() {

    var wow = new WOW({
      boxClass: 'wow', // 类名，在用户滚动时显示隐藏的框。
      animateClass: 'animate__animated', // 触发CSS动画的类名称
      offset: 100, // 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并到达此距离时，隐藏的框会显示出来。
      mobile: true, // 在移动设备上打开/关闭WOW.js。
      live: true, // 在页面上同时检查新的WOW元素。
      // callback: function(box) {
      //   //每次启动动画时都会触发回调
      //   // //传入的参数是正在动画的DOM节点
      // },
      scrollContainer: '#specific-scroll-container', //  可选滚动容器选择器，否则使用window，
      resetAnimation: true,

    })

    this.$nextTick(() => {
      wow.init()
    });

    // this.getDomainData();
     let androidImg = `https://console.eztcloud.com//static/wx/wxdw.html`;  
     let h5img = 'https://www.eztcloud.com/';
     this.setQrCode(androidImg, h5img);

  },
  methods: {
    playVideo(){
      this.$refs.videoBox&&this.$refs.videoBox.showVideo();
    },
    getDomainData() {
      this.$api.request({
        url: '/api/domain/',
        methods: 'GET',
      }).then(res => {

        console.log('domain',res)
        if (res.status == 200) {
          // let androidImg = `${window.location&&window.location.origin}/static/wx/wxdw.html`;
          let androidImg = `https://console.eztcloud.com//static/wx/wxdw.html`;
          // let h5img = res.data.mobile_url;
          let h5img = 'https://www.eztcloud.com/';
        
          this.setQrCode(androidImg, h5img);

        }
      })
    },
    setQrCode(androidImg, h5img) {
      
      this.$generateQR(androidImg).then(res => {
        const image = new Image();
        image.src = res;
        image.width = 140;
        image.height = 140;
        document.querySelector('#androidBox').appendChild(image);
      });
      this.$generateQR(h5img).then(res => {
        const image = new Image();
        image.src = res;
        image.width = 140;
        image.height = 140;
        document.querySelector('#h5Box').appendChild(image);
      });
    },

    isMobileDevice() {
      return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    openUrl(url) {
      window.open(url)
    },
    openForm() {
      this.dialogFormVisible = true
    },
    onTrial() {
      // let url = 'https://api.eztcloud.com' + '/api/v1/iam/login/?next=' + "https://console.eztcloud.com/%23/login/%3Fproduction%3Dtrue";
      // let url = 'https://api.eztcloud.com' + '/api/v1/iam/login/?next=' + "http://192.168.1.13:8081/%23/login/%3Fproduction%3Dtrue";
      // window.location.href = url;
      window.location.href = "https://console.eztcloud.com/#/login/?production=true";
    },
    onTrialM() {
      // %23/pages/login/login
      // let url = 'https://api.eztcloud.com' + '/api/v1/iam/login/?next=' + "https://m.eztcloud.com/%23/pages/index/index";
      // let url = 'https://api.eztcloud.com' + '/api/v1/iam/login/?next=' + "http://192.168.1.13:8081/%23/pages/index/index";
      // window.location.href = url;
      window.location.href = "https://m.eztcloud.com/#/pages/index/index";
    },
    selectTab(index) { // 选择 Tab 的方法。
      this.activeIndex = index; // 更新激活的 Tab 索引。
    },
    handleScroll() {
      let _this = this
      this.refArray.forEach((r) => {
        _this.gdjz(r.ref, 20, () => {
          _this[r.show] = true
        })
      })
    },

    gdjz(div, offset, callback) {

      let dom = this.$refs[div]
      if (dom) {
        var a, b, c, d;
        d = dom.offsetTop
        a = eval(d + offset)
        b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
        c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
        if (b + c > a) {
          callback && callback()
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.pc {

  .home {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .title {
      height: 40px;
      background-color: #fff;
      padding: 0 20px;
      display: flex;
      align-items: center;
      box-shadow: 0 0 64px 0 rgba(0, 0, 0, 0.1);

      .title_left {
        flex: 1;
        display: flex;
        align-items: center;

        .title_img {
          height: 20px;
        }
      }

      .title_right {
        display: flex;
        align-items: center;

        .button {
          height: 25px;
          font-size: 10px;
        }

        .button {
          // @media (max-width: 1200px) {
          //   height: 25px;
          //   font-size: 10px;
          // }
        }
      }

    }

    .content {
      flex: 1;
      overflow-y: auto;

      .box1 {
        color: #000;
        background-image: url('~@/assets/image/home.png');
        background-size: 100% 1200px;
        background-repeat: no-repeat;
        background-position: center -70px;

        // @media (max-width: 1200px) {
        //   background-size: 100% 1000px;
        // }

        .box1_title {
          padding: 5px 0;
          animation: slideInLeft;
          animation-duration: 2s;
          text-align: center;

          .font_b {
            font-size: 45px;
            font-weight: 600;
          }

          .font_l {
            font-size: 30px;
            position: relative;
            top: -20px;
          }

          .font_s {
            font-size: 18px;
            font-weight: 600;
            margin-left: -8px;
          }
        }

        .box1_title2 {
          color: #000;
          font-size: 30px;
          text-align: center;
          animation: slideInRight;
          animation-duration: 2s;
          padding-bottom: 10px;
        }

        .box1_title3 {
          color: #333;
          font-size: 12px;
          text-align: center;
          animation: zoomIn;
          animation-duration: 2.5s;
        }

        .box1_video_box {
          animation: zoomIn;
          animation-duration: 1.5s;
          background-color: #fff;
          overflow: hidden;
          width: 60%;
          height: 450px;
          // padding: 8px;
          margin: 0 auto;
          margin-top: 15px;
          border-radius: 10px;
          box-sizing: border-box;
          padding: 10px;

          // @media (max-width: 1200px) {
          //   width: 90%;
          //   height: 200px;
          // }

          video {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }

          margin-bottom: 65px;
        }
      }

      .box2 {
        min-height: 300px;
        padding-bottom: 30px;

        .box2_title {
          text-align: center;
          color: #fff;
          font-size: 40px;
          padding-bottom: 15px;
          // animation: zoomIn;
          // animation-duration: 2.5s;

          // @media (max-width: 1200px) {
          //   font-size: 30px;
          // }

          margin: 0 auto;
        }

        .box2_title2 {
          width: 540px;
          text-align: center;
          color: #fff;
          font-size: 15px;
          padding-bottom: 15px;
          margin: 0 auto;
          // animation: zoomIn;
          // animation-duration: 2.5s;

          // @media (max-width: 1200px) {
          //   width: 100%;
          //   padding: 0 25px;
          //   box-sizing: border-box;
          //   font-size: 12px;
          // }
        }

        .box2_content {
          position: relative;
          width: 75%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;

          // @media (max-width: 1200px) {
          //   width: 90%;
          // }

          .box2_content_1 {
            // animation: flipInY;
            // animation-duration: 2.5s;
            width: 46%;
            background-color: #fff;
            box-sizing: border-box;
            border-radius: 20px;
            padding: 37px;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);

            // @media (max-width: 1200px) {
            //   width: 100%;
            // }

            span {
              display: block;
            }

            .content_1_sapan {
              color: #333;
              font-size: 20px;
              font-weight: 600;
            }

            .content_2_sapan {
              color: #333;
              font-size: 26px;
              margin-top: 15px;
            }

            .content_3_sapan {
              color: #666;
              font-size: 13px;
              line-height: 24px;
              margin-top: 24px;
            }

            .content_item {
              border-radius: 8px;
              border: 1px solid rgba(17, 0, 102, 0.1);
              display: flex;
              padding: 10px;
              margin-top: 10px;
              align-items: center;

              img {
                width: 40px;
                height: 40px;
                margin-right: 12px;

                // @media (max-width: 1200px) {
                //   width: 55px;
                //   height: 55px;
                // }
              }

              .item_right {
                flex: 1;
                display: flex;
                flex-direction: column;

                .item_top {
                  color: #343434;
                  font-size: 13px;
                  // margin-bottom: 8px;
                }

                .item_bottom {
                  color: #767676;
                  font-size: 9px;
                }
              }

            }
          }

          .box2_content_2 {
            transition: transform 0.3s ease;
            // animation: flipInX;
            // animation-duration: 2.5s;
            width: 50%;
            height: 110px;
            background-color: #000;
            position: absolute;
            top: 0;
            right: 0;
            background: #77a9e6;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);
            border-radius: 20px;
            box-sizing: border-box;
            padding: 20px 28px;
            color: #fff;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);

            // @media (max-width: 1200px) {
            //   width: 100%;
            //   position: relative;
            //   margin-top: 20px;
            //   height: 130px;
            // }

            span {
              display: block;
            }

            .content_1_sapan {
              font-size: 26px;
              font-weight: 600;
            }

            .content_2_sapan {
              font-size: 20px;
              margin-top: 5px;
            }

            .content_3_sapan {
              font-size: 13px;
              line-height: 24px;
              margin-top: 28px;
            }
          }

          .box2_content_3 {
            // animation: flipInX;
            // animation-duration: 2.5s;
            width: 50%;
            height: 110px;
            background-color: #10243D;
            position: absolute;
            bottom: 0;
            right: 0;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 20px 28px;
            color: #fff;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);

            // @media (max-width: 1200px) {
            //   width: 100%;
            //   position: relative;
            //   margin-top: 20px;
            //   height: 130px;
            // }

            span {
              display: block;
            }

            .content_1_sapan {
              font-size: 26px;
              font-weight: 600;
            }

            .content_2_sapan {
              font-size: 20px;
              margin-top: 5px;
            }

            .content_3_sapan {
              font-size: 13px;
              line-height: 24px;
              margin-top: 28px;
            }
          }
        }

      }

      .box3 {
        .box3_title {
          text-align: center;
          color: #000;
          font-size: 40px;
          font-weight: 600;
          padding-bottom: 15px;

          // @media (max-width: 1200px) {
          //   font-size: 30px;
          // }

          margin: 0 auto;
        }

        .box3_title2 {
          width: 540px;
          text-align: center;
          color: #666;
          font-size: 15px;
          padding-bottom: 15px;
          margin: 0 auto;

          // @media (max-width: 1200px) {
          //   width: 100%;
          //   padding: 0 25px;
          //   box-sizing: border-box;
          //   font-size: 12px;
          // }
        }

        .box3_content {
          width: 75%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          // @media (max-width: 1200px) {
          //   width: 90%;
          //   display: block;
          //   flex-wrap: nowrap;
          // }

          .box3_content_item {
            width: 23%;
            height: 340px;
            border-radius: 12px;
            // border: 4px solid #6e707023;
            position: relative;
            margin-bottom: 20px;
            padding: 15px 25px;
            box-sizing: border-box;
            box-shadow: 2px 2px 14px 0px rgba(29, 28, 28, 0.2);
            border-top: 12px solid #3874F5;
            display: flex;
            justify-content: space-between;

            // @media (max-width: 1200px) {
            //   width: 100%;
            //   height: 420px;
            // }

            .box3_content_item_img_box {
              padding: 0 10px 20px 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;

              .box3_content_item_img {
                width: 40px;
                height: 40px;
              }
            }

            .text {
              position: absolute;
              bottom: 25px;
              left: 50%;
              transform: translateX(-50%);
              color: #000;
              font-size: 14px;
              font-weight: 600;
            }

          }

          .box3_content_item:nth-of-type(2) {
            width: 50%;
            border: 1px dashed #80A6F9;

            .box3_content_item_img_text {
              display: flex;
              align-items: center;
              justify-content: space-between;

              // @media (max-width: 1200px) {
              //   flex-direction: column;
              //   position: relative;
              //   height: 60px;
              //   width: 80px;

              //   span {
              //     position: absolute;
              //     bottom: 0;
              //   }
              // }
            }

            .box3_content_item_logo {
              height: 100px;
              line-height: 100px;
              background: linear-gradient(128deg, #EDF5FF 0%, #DCEAFF 100%);
              border-radius: 12px;
              width: 120px;
              text-align: center;
              font-weight: 600;
              font-size: 18px;
              position: relative;
              top: 50%;
              transform: translateY(-50%);
              color: #3874F5;

              // @media (max-width: 1200px) {
              //   font-weight: 600;
              //   font-size: 14px;
              //   height: 70px;
              //   line-height: 70px;
              // }
            }

            // @media (max-width: 1200px) {
            //   width: 100%;

            // }
          }

          .box3_content_item:nth-of-type(3) {
            justify-content: space-evenly;

            .box3_content_item_img_box {
              justify-content: space-evenly;

            }
          }
        }
      }

      .box4 {
        padding: 40px 0;
        background: linear-gradient(128deg, #EDF5FF 0%, #DCEAFF 100%);

        // @media (max-width: 1200px) {
        //   display: none;
        // }

        @media (min-width: 1200px) {
          display: block;
        }

        .box4_title {
          text-align: center;
          color: #666;
          font-size: 30px;
          padding-bottom: 40px;

          // @media (max-width: 1200px) {
          //   font-size: 24px;
          // }

          margin: 0 auto;
        }

        .tabs {
          width: 75%;

          // @media (max-width: 1200px) {
          //   width: 90%;
          // }

          margin: 0 auto;

          ::v-deep .el-tabs__nav {
            width: 100% !important;
            justify-content: space-between !important;

            // @media (max-width: 1200px) {
            //   width: auto;
            //   justify-content: left;
            // }
          }

          ::v-deep .el-tabs__item {
            @media (max-width: 1200px) {
              padding: 0 0px !important;
            }
          }

          ::v-deep .is-active {
            color: #3773F5;
          }

          ::v-deep .el-tabs__active-bar {
            height: 8px;
            border-radius: 4px;
            bottom: -3px;
            background-color: #3773F5;

            // @media (max-width: 1200px) {
            //   height: 2px;
            //   bottom: 0px;
            // }
          }

          ::v-deep .el-tabs__nav-scroll {
            overflow: visible !important;
          }

          ::v-deep .el-tabs__nav-wrap {
            overflow: visible !important;
          }
        }

        .pane-box {
          padding: 30px;
          display: flex;

          // @media (max-width: 1200px) {
          //   display: block;
          // }

          .pane-box-left {
            height: 350px;
            width: 460px;

            // @media (max-width: 1200px) {
            //   height: 280px;
            // }

            .pane-left-title {
              font-size: 18px;
              margin: 30px 0;
              font-weight: 600;
            }

            .pane-left-text {
              display: flex;
              align-items: center;
              color: #666;
              margin-bottom: 20px;
              font-size: 12px;
            }
          }

          .pane-box-right {
            width: 100%;
            position: relative;

            img {
              width: 80%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }

      .box41 {
        padding: 40px 0;
        height: 4090px;

        @media (min-width: 1200px) {
          display: none;
        }

        // @media (max-width: 1200px) {
        //   display: block;
        // }

        // position: relative;

        .box41-box {
          padding: 30px;
          height: 530px;
          background: linear-gradient(128deg, #EDF5FF 0%, #DCEAFF 100%);

          .box41-title {
            text-align: center;
            color: #666;
            font-size: 24px;
            margin: 0 auto;
            margin-bottom: 15px;
          }

          .box41-box-left {
            height: 260px;
            width: 320px;

            .box41-left-title {
              font-size: 18px;
              margin: 30px 0;
              font-weight: 600;
            }

            .box41-left-text {
              display: flex;
              align-items: center;
              color: #666;
              margin-bottom: 20px;
              font-size: 12px;
            }
          }

          .box41-box-right {
            width: 100%;
            height: 240px;
            position: relative;

            img {
              height: 90%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }

      .box5 {
        background-color: #060026;
        color: #fff;

        .box5_content {
          width: 75%;
          margin: 0 auto;
          border-bottom: 1px solid #ddd;

          .box5_title {
            display: flex;
            align-items: center;
            font-size: 16px;

            .box5_logo {
              img {
                width: 80px;
                margin-right: 20px;
              }
            }
          }

          .box5_item {
            color: #ddd;
            padding-left: 100px;

            .box5_item_title {
              font-size: 13px;
              margin-bottom: 20px;
              font-weight: 400;
              color: #ddd;
              position: relative;

              &::after {
                content: ' ';
                height: 3px;
                width: 16px;
                position: absolute;
                background-color: #3773F5;
                bottom: -3px;
                left: 0;
              }
            }

            .box5_item_text {
              font-size: 10px;
              font-weight: 400;
              margin-bottom: 30px;
              display: flex;
              justify-content: space-between;

              // @media (max-width: 1200px) {
              //   display: block;

              //   span {
              //     display: block;
              //     margin-bottom: 15px;
              //   }
              // }
            }

          }
        }

        .ICP {
          color: #fff;
          font-size: 10px;
          font-weight: 400;
          padding: 20px 0 30px 0;
          text-align: center;

        }

      }

    }
  }

  .boxhover {
    &:hover {
      box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.3) !important;
      filter: brightness(0.95);
      transform: scale(1.01) !important;
    }
  }

  .button {
    font-family: 'AlibabaPuHuiTi-3-55-Regular';
    font-size: 12px;
  }

  ::v-deep .el-form-item__label {
    font-size: 12px !important;
  }

  ::v-deep .el-input__inner {
    font-size: 12px !important;
  }

  ::v-deep .el-textarea__inner {
    font-size: 12px !important;
  }

  ::v-deep .el-dialog {
    width: 500px;

    // @media (max-width: 1200px) {
    //   width: 80%;
    // }
  }

  .qrcode {
    width: 300px;
    height: 300px;
    background-color: #fff;
    border-radius: 15px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .toPC {
    // @media (max-width: 1200px) {
    //   display: none;
    // }

    @media (min-width: 1200px) {
      display: inline-block;
    }
  }

  .toM {
    // @media (max-width: 1200px) {
    //   display: inline-block;
    // }

    @media (min-width: 1200px) {
      display: none;
    }
  }
}

.phone {
  .home {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .title {
      height: 40px;
      background-color: #fff;
      padding: 0 20px;
      display: flex;
      align-items: center;
      box-shadow: 0 0 64px 0 rgba(0, 0, 0, 0.1);

      .title_left {
        flex: 1;
        display: flex;
        align-items: center;

        .title_img {
          height: 20px;
        }
      }

      .title_right {
        .button {
          height: 25px;
          font-size: 10px;
        }

        .button {
          @media (max-width: 1200px) {
            height: 25px;
            font-size: 10px;
          }
        }
      }

    }

    .content {
      flex: 1;
      overflow-y: auto;

      .box1 {
        color: #000;
        background-image: url('~@/assets/image/home.png');
        background-size: 100% 1200px;
        background-repeat: no-repeat;
        background-position: center -70px;

        @media (max-width: 1200px) {
          background-size: 100% 1000px;
        }

        .box1_title {
          padding: 5px 0;
          animation: slideInLeft;
          animation-duration: 2s;
          text-align: center;

          .font_b {
            font-size: 45px;
            font-weight: 600;
          }

          .font_l {
            font-size: 30px;
            position: relative;
            top: -20px;
          }

          .font_s {
            font-size: 18px;
            font-weight: 600;
            margin-left: -8px;
          }
        }

        .box1_title2 {
          color: #000;
          font-size: 30px;
          text-align: center;
          animation: slideInRight;
          animation-duration: 2s;
          padding-bottom: 10px;
        }

        .box1_title3 {
          color: #333;
          font-size: 12px;
          text-align: center;
          animation: zoomIn;
          animation-duration: 2.5s;
        }

        .box1_video_box {
          animation: zoomIn;
          animation-duration: 1.5s;
          background-color: #fff;
          overflow: hidden;
          width: 60%;
          height: 450px;
          // padding: 8px;
          margin: 0 auto;
          margin-top: 15px;
          border-radius: 10px;
          box-sizing: border-box;
          padding: 10px;

          @media (max-width: 1200px) {
            width: 90%;
            height: 200px;
          }

          video {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }

          margin-bottom: 65px;
        }
      }

      .box2 {
        min-height: 300px;
        padding-bottom: 30px;

        .box2_title {
          text-align: center;
          color: #fff;
          font-size: 40px;
          padding-bottom: 15px;
          // animation: zoomIn;
          // animation-duration: 2.5s;

          @media (max-width: 1200px) {
            font-size: 30px;
          }

          margin: 0 auto;
        }

        .box2_title2 {
          width: 540px;
          text-align: center;
          color: #fff;
          font-size: 15px;
          padding-bottom: 15px;
          margin: 0 auto;
          // animation: zoomIn;
          // animation-duration: 2.5s;

          @media (max-width: 1200px) {
            width: 100%;
            padding: 0 25px;
            box-sizing: border-box;
            font-size: 12px;
          }
        }

        .box2_content {
          position: relative;
          width: 75%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;

          @media (max-width: 1200px) {
            width: 90%;
          }

          .box2_content_1 {
            // animation: flipInY;
            // animation-duration: 2.5s;
            width: 46%;
            background-color: #fff;
            box-sizing: border-box;
            border-radius: 20px;
            padding: 37px;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);

            @media (max-width: 1200px) {
              width: 100%;
            }

            span {
              display: block;
            }

            .content_1_sapan {
              color: #333;
              font-size: 20px;
              font-weight: 600;
            }

            .content_2_sapan {
              color: #333;
              font-size: 26px;
              margin-top: 15px;
            }

            .content_3_sapan {
              color: #666;
              font-size: 13px;
              line-height: 24px;
              margin-top: 24px;
            }

            .content_item {
              border-radius: 8px;
              border: 1px solid rgba(17, 0, 102, 0.1);
              display: flex;
              padding: 10px;
              margin-top: 10px;
              align-items: center;

              img {
                width: 40px;
                height: 40px;
                margin-right: 12px;

                @media (max-width: 1200px) {
                  width: 55px;
                  height: 55px;
                }
              }

              .item_right {
                flex: 1;
                display: flex;
                flex-direction: column;

                .item_top {
                  color: #343434;
                  font-size: 13px;
                  // margin-bottom: 8px;
                }

                .item_bottom {
                  color: #767676;
                  font-size: 9px;
                }
              }

            }
          }

          .box2_content_2 {
            transition: transform 0.3s ease;
            // animation: flipInX;
            // animation-duration: 2.5s;
            width: 50%;
            height: 110px;
            background-color: #000;
            position: absolute;
            top: 0;
            right: 0;
            background: #77a9e6;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);
            border-radius: 20px;
            box-sizing: border-box;
            padding: 20px 28px;
            color: #fff;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);

            @media (max-width: 1200px) {
              width: 100%;
              position: relative;
              margin-top: 20px;
              height: 130px;
            }

            span {
              display: block;
            }

            .content_1_sapan {
              font-size: 26px;
              font-weight: 600;
            }

            .content_2_sapan {
              font-size: 20px;
              margin-top: 5px;
            }

            .content_3_sapan {
              font-size: 13px;
              line-height: 24px;
              margin-top: 28px;
            }
          }

          .box2_content_3 {
            // animation: flipInX;
            // animation-duration: 2.5s;
            width: 50%;
            height: 110px;
            background-color: #10243D;
            position: absolute;
            bottom: 0;
            right: 0;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 20px 28px;
            color: #fff;
            box-shadow: 0px 0px 64px 0px rgba(8, 107, 153, 0.05);

            @media (max-width: 1200px) {
              width: 100%;
              position: relative;
              margin-top: 20px;
              height: 130px;
            }

            span {
              display: block;
            }

            .content_1_sapan {
              font-size: 26px;
              font-weight: 600;
            }

            .content_2_sapan {
              font-size: 20px;
              margin-top: 5px;
            }

            .content_3_sapan {
              font-size: 13px;
              line-height: 24px;
              margin-top: 28px;
            }
          }
        }

      }

      .box3 {
        .box3_title {
          text-align: center;
          color: #000;
          font-size: 40px;
          font-weight: 600;
          padding-bottom: 15px;

          @media (max-width: 1200px) {
            font-size: 30px;
          }

          margin: 0 auto;
        }

        .box3_title2 {
          width: 540px;
          text-align: center;
          color: #666;
          font-size: 15px;
          padding-bottom: 15px;
          margin: 0 auto;

          @media (max-width: 1200px) {
            width: 100%;
            padding: 0 25px;
            box-sizing: border-box;
            font-size: 12px;
          }
        }

        .box3_content {
          width: 75%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          @media (max-width: 1200px) {
            width: 90%;
            display: block;
            flex-wrap: nowrap;
          }

          .box3_content_item {
            width: 23%;
            height: 340px;
            border-radius: 12px;
            // border: 4px solid #6e707023;
            position: relative;
            margin-bottom: 20px;
            padding: 15px 25px;
            box-sizing: border-box;
            box-shadow: 2px 2px 14px 0px rgba(29, 28, 28, 0.2);
            border-top: 12px solid #3874F5;
            display: flex;
            justify-content: space-between;

            @media (max-width: 1200px) {
              width: 100%;
              height: 420px;
            }

            .box3_content_item_img_box {
              padding: 0 10px 20px 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;

              .box3_content_item_img {
                width: 40px;
                height: 40px;
              }
            }

            .text {
              position: absolute;
              bottom: 25px;
              left: 50%;
              transform: translateX(-50%);
              color: #000;
              font-size: 14px;
              font-weight: 600;
            }

          }

          .box3_content_item:nth-of-type(2) {
            width: 50%;
            border: 1px dashed #80A6F9;

            .box3_content_item_img_text {
              display: flex;
              align-items: center;
              justify-content: space-between;

              @media (max-width: 1200px) {
                flex-direction: column;
                position: relative;
                height: 60px;
                width: 80px;

                span {
                  position: absolute;
                  bottom: 0;
                }
              }
            }

            .box3_content_item_logo {
              height: 100px;
              line-height: 100px;
              background: linear-gradient(128deg, #EDF5FF 0%, #DCEAFF 100%);
              border-radius: 12px;
              width: 120px;
              text-align: center;
              font-weight: 600;
              font-size: 18px;
              position: relative;
              top: 50%;
              transform: translateY(-50%);
              color: #3874F5;

              @media (max-width: 1200px) {
                font-weight: 600;
                font-size: 14px;
                height: 70px;
                line-height: 70px;
              }
            }

            @media (max-width: 1200px) {
              width: 100%;

            }
          }

          .box3_content_item:nth-of-type(3) {
            justify-content: space-evenly;

            .box3_content_item_img_box {
              justify-content: space-evenly;

            }
          }
        }
      }

      .box4 {
        padding: 40px 0;
        background: linear-gradient(128deg, #EDF5FF 0%, #DCEAFF 100%);

        @media (max-width: 1200px) {
          display: none;
        }

        @media (min-width: 1200px) {
          display: block;
        }

        .box4_title {
          text-align: center;
          color: #666;
          font-size: 30px;
          padding-bottom: 40px;

          @media (max-width: 1200px) {
            font-size: 24px;
          }

          margin: 0 auto;
        }

        .tabs {
          width: 75%;

          @media (max-width: 1200px) {
            width: 90%;
          }

          margin: 0 auto;

          ::v-deep .el-tabs__nav {
            width: 100% !important;
            justify-content: space-between !important;

            @media (max-width: 1200px) {
              width: auto;
              justify-content: left;
            }
          }

          ::v-deep .el-tabs__item {
            @media (max-width: 1200px) {
              padding: 0 0px !important;
            }
          }

          ::v-deep .is-active {
            color: #3773F5;
          }

          ::v-deep .el-tabs__active-bar {
            height: 8px;
            border-radius: 4px;
            bottom: -3px;
            background-color: #3773F5;

            @media (max-width: 1200px) {
              height: 2px;
              bottom: 0px;
            }
          }

          ::v-deep .el-tabs__nav-scroll {
            overflow: visible !important;
          }

          ::v-deep .el-tabs__nav-wrap {
            overflow: visible !important;
          }
        }

        .pane-box {
          padding: 30px;
          display: flex;

          @media (max-width: 1200px) {
            display: block;
          }

          .pane-box-left {
            height: 350px;
            width: 460px;

            @media (max-width: 1200px) {
              height: 280px;
            }

            .pane-left-title {
              font-size: 18px;
              margin: 30px 0;
              font-weight: 600;
            }

            .pane-left-text {
              display: flex;
              align-items: center;
              color: #666;
              margin-bottom: 20px;
              font-size: 12px;
            }
          }

          .pane-box-right {
            width: 100%;
            position: relative;

            img {
              height: 90%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }

      .box41 {
        padding: 40px 0;
        height: 4090px;

        @media (min-width: 1200px) {
          display: none;
        }

        @media (max-width: 1200px) {
          display: block;
        }

        // position: relative;

        .box41-box {
          padding: 30px;
          height: 530px;
          background: linear-gradient(128deg, #EDF5FF 0%, #DCEAFF 100%);

          .box41-title {
            text-align: center;
            color: #666;
            font-size: 24px;
            margin: 0 auto;
            margin-bottom: 15px;
          }

          .box41-box-left {
            height: 260px;
            width: 320px;

            .box41-left-title {
              font-size: 18px;
              margin: 30px 0;
              font-weight: 600;
            }

            .box41-left-text {
              display: flex;
              align-items: center;
              color: #666;
              margin-bottom: 20px;
              font-size: 12px;
            }
          }

          .box41-box-right {
            width: 100%;
            height: 240px;
            position: relative;

            img {
              height: 90%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }

      .box5 {
        background-color: #060026;
        color: #fff;

        .box5_content {
          width: 75%;
          margin: 0 auto;
          border-bottom: 1px solid #ddd;

          .box5_title {
            display: flex;
            align-items: center;
            font-size: 16px;

            .box5_logo {
              img {
                width: 80px;
                margin-right: 20px;
              }
            }
          }

          .box5_item {
            color: #ddd;
            padding-left: 100px;

            .box5_item_title {
              font-size: 13px;
              margin-bottom: 20px;
              font-weight: 400;
              color: #ddd;
              position: relative;

              &::after {
                content: ' ';
                height: 3px;
                width: 16px;
                position: absolute;
                background-color: #3773F5;
                bottom: -3px;
                left: 0;
              }
            }

            .box5_item_text {
              font-size: 10px;
              font-weight: 400;
              margin-bottom: 30px;
              display: flex;
              justify-content: space-between;

              @media (max-width: 1200px) {
                display: block;

                span {
                  display: block;
                  margin-bottom: 15px;
                }
              }
            }

          }
        }

        .ICP {
          color: #fff;
          font-size: 10px;
          font-weight: 400;
          padding: 20px 0 30px 0;
          text-align: center;

        }

      }

    }
  }

  .boxhover {
    &:hover {
      box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.3) !important;
      filter: brightness(0.95);
      transform: scale(1.01) !important;
    }
  }

  .button {
    font-family: 'AlibabaPuHuiTi-3-55-Regular';
    font-size: 12px;
  }

  ::v-deep .el-form-item__label {
    font-size: 12px !important;
  }

  ::v-deep .el-input__inner {
    font-size: 12px !important;
  }

  ::v-deep .el-textarea__inner {
    font-size: 12px !important;
  }

  ::v-deep .el-dialog {
    width: 500px;

    @media (max-width: 1200px) {
      width: 80%;
    }
  }

  .qrcode {
    width: 300px;
    height: 300px;
    background-color: #fff;
    border-radius: 15px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .toPC {
    @media (max-width: 1200px) {
      display: none;
    }

    @media (min-width: 1200px) {
      display: inline-block;
    }
  }

  .toM {
    @media (max-width: 1200px) {
      display: inline-block;
    }

    @media (min-width: 1200px) {
      display: none;
    }
  }
}
</style>
